import NextLink from 'next/link';

import { Typography } from '../typography';
import styles from './Link.module.css';

interface LinkProps {
  theme?: Component.Link.Theme;
  children: React.ReactNode;
  onClick?: TypeAny;
  inherit?: boolean;
  isBlock?: boolean;
  target?: string;
  href?: string;
}

export function Link({
  theme = 'none',
  children,
  onClick,
  inherit,
  isBlock,
  target,
  href = ''
}: LinkProps) {
  if (!href && !onClick) return null;

  return (
    <NextLink
      data-testid="linkComponent"
      className={styles.link}
      data-is-block={isBlock}
      data-inherit={inherit}
      data-theme={theme}
      onClick={onClick}
      target={target}
      href={href}
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
    >
      <Typography sizes={['link']}>{children}</Typography>
    </NextLink>
  );
}
